module.exports = __webpack_public_path__ + "img/home-icon-1.fb8c87e4.svg";